<template>
  <div
    class="flex flex-col items-center overflow-hidden rounded-card border border-line
           bg-card px-3 py-2.5 text-center"
    :class="interactive ? 'cursor-pointer transition-colors duration-150 hover:border-accent hover:bg-bg2' : ''"
  >
    <span class="text-label text-text-muted mb-2">{{ label }}</span>
    <div class="flex w-full min-w-0 flex-1 flex-col items-center justify-center gap-2">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true,
  },
  // tiles that open a dropdown react to hover
  interactive: {
    type: Boolean,
    default: false,
  },
});
</script>
